<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      tag="div"
      :class="{ on: item.url == $route.fullPath }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <img :src="item.url == $route.fullPath ? item.icon2 : item.icon1" />
      <div>{{ item.name }}</div>
    </router-link>
    <div class="item">
      <wx-open-launch-weapp
        appid="wx820962db7d5f2abb"
        username="gh_71dc8139aba8"
        path="pages/index/index"
      >
        <script v-is="script" type="text/wxtag-template">
          <style v-is="style">
          .icon {
              width: 24px;
              height: 24px;
          }
          .text{
                font-size: 13px;
              }
          </style>
            <div class="item">
                      <img class="icon" src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/icon_06.png" />
                      <div class="text">商城</div>
            </div>
        </script>
      </wx-open-launch-weapp>
    </div>
    <div class="item">
      <wx-open-launch-weapp
        appid="wx820962db7d5f2abb"
        username="gh_71dc8139aba8"
        path="pages/users/user_integral/index"
      >
        <script v-is="script" type="text/wxtag-template">
          <style v-is="style">
          .icon {
              width: 24px;
              height: 24px;
          }
          .text{
                font-size: 13px;
              }
          </style>
            <div class="item">
                      <img class="icon" src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/icon_03.png" />
                      <div class="text">积分</div>
            </div>
        </script>
      </wx-open-launch-weapp>
    </div>
    <div class="item">
      <wx-open-launch-weapp
        appid="wx820962db7d5f2abb"
        username="gh_71dc8139aba8"
        path="pages/user/index"
      >
        <script v-is="script" type="text/wxtag-template">
          <style v-is="style">
          .icon {
              width: 24px;
              height: 24px;
          }
          .text{
                font-size: 13px;
              }
          </style>
            <div class="item">
                      <img class="icon" src="https://dodui.oss-cn-shenzhen.aliyuncs.com/2022jiaodianyinliu/icon_05.png" />
                      <div class="text">我的</div>
            </div>
        </script>
      </wx-open-launch-weapp>
    </div>
  </div>
</template>
<script>
import { getTeamList } from "@/api/public";
import { getWechatConfig } from "@api/public";
import wx from "weixin-js-sdk";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "推荐",
          icon1: require("../assets/images/icon_01.png"),
          icon2: require("../assets/images/icon_01_ac.png"),
          url: "/",
        },
      ],
      footerList1: [
        {
          name: "商城",
          icon1: require("../assets/images/icon_06.png"),
          icon2: require("../assets/images/icon_06.png"),
          url: "pages/index/index",
        },
        {
          name: "积分",
          icon1: require("../assets/images/icon_03.png"),
          icon2: require("../assets/images/icon_03_ac.png"),
          url: "pages/users/user_integral/index",
        },
        {
          name: "我的",
          icon1: require("../assets/images/icon_05.png"),
          icon2: require("../assets/images/icon_05_ac.png"),
          url: "pages/user/index",
        },
      ],
      teamStatus: false,
    };
  },
  mounted() {
    getWechatConfig().then((data) => {
      console.log(data.data);
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      });
      wx.error(function() {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
    console.log(this.$route);
    this.getTeamList();
  },
  methods: {
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList()
        .then((res) => {
          this.teamStatus = true;
        })
        .catch((err) => {
          if (err.data.msg == "数据不存在！") {
            this.teamStatus = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  font-size: 0;
  img {
    width: 0.48rem;
    height: 0.48rem;
  }
}
</style>
